export * from './duration-status.pipe';
export * from './duration-status.module';
